import { render, staticRenderFns } from "./deploy-card.vue?vue&type=template&id=54d6da2e&scoped=true&"
import script from "./deploy-card.vue?vue&type=script&lang=js&"
export * from "./deploy-card.vue?vue&type=script&lang=js&"
import style0 from "./deploy-card.vue?vue&type=style&index=0&id=54d6da2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6da2e",
  null
  
)

export default component.exports